import { createSlice } from "@reduxjs/toolkit";

import { PermissionsEntities } from "store/permissions/types";

import {
  getAllPermissions,
  getUserPermissionByEntity,
  getUserPermissions,
} from "./actions";
import { Permission } from "./types";

type PermissionEntry = {
  [key: number]: {
    [key: string]: boolean;
  };
};

export type PermissionsState = {
  error: any;
  loading: boolean;
  permissions: Permission[];
  userPermissions: { [key: string]: boolean }[];
  userPermissionsByEntity: {
    [PermissionsEntities.VOTING]?: PermissionEntry[];
    [PermissionsEntities.MEETING]?: PermissionEntry[];
    [PermissionsEntities.TASK]?: PermissionEntry[];
    [PermissionsEntities.WORKSPACE]?: PermissionEntry[];
  } | null;
};

const initialState: PermissionsState = {
  error: false,
  loading: false,
  permissions: [],
  userPermissions: [],
  userPermissionsByEntity: null,
};

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get all permissions
    builder.addCase(getAllPermissions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getAllPermissions.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getAllPermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.permissions = action.payload.data;
    });

    //get user permissions
    builder.addCase(getUserPermissions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getUserPermissions.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getUserPermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.userPermissions = action.payload.data;
    });

    //get user permission by entity
    builder.addCase(getUserPermissionByEntity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getUserPermissionByEntity.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getUserPermissionByEntity.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.userPermissionsByEntity = {
        ...state.userPermissionsByEntity,
        [action.payload.type]: {
          ...state.userPermissionsByEntity?.[action.payload.type],
          [action.payload.id]: action.payload.data.data,
        },
      };
    });
  },
});
